/** @jsxImportSource @emotion/react */
import MenuButton from 'apollo-react/components/MenuButton'

const Organizations = ({ headerBar }) => {
  const label = labelName => {
    return (
      <span
        style={{
          maxWidth: '450px',
          textWrap: 'wrap',
        }}
      >
        {labelName}
      </span>
    )
  }

  const organizationList = headerBar?.meta?.institutions.map(organization => {
    return {
      text: label(organization.label),
      onClick: () => {
        window.location.href = `/institutions/${organization.id}`
      },
    }
  })

  return (
    <MenuButton
      buttonText="My Organizations"
      sx={{
        '&.MuiButtonBase-root': {
          border: 'none',
        },
      }}
      menuItems={organizationList}
    />
  )
}

export default Organizations
